import { ContextStore } from 'bernie-plugin-mobx';
import { inject } from 'mobx-react';
import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { PropertyReviews } from '@shared-ui/lodging-reviews';
import { RefTarget } from '@shared-ui/ref-context';
import { useDialog } from '@shared-ui/dialog-context';

import { adaptSearchCriteria } from 'stores/adapters/bex-api/common/search-criteria-adapter';
import { CurrentHotelStore } from 'stores/current-hotel-store';

import { UitkSheet } from 'uitk-react-sheet';
import { UitkSpacing } from 'uitk-react-spacing';

import { SharedUiPropertyReviewsDialog } from './shared-ui-property-reviews-dialog';
import { SimpleLazyLoadWrapper } from 'components/common/lazy/simple-lazy-load-wrapper';

interface SharedUiPropertyReviewsWrapperProps {
  currentHotel?: CurrentHotelStore;
  context?: ContextStore;
}

export const sharedUIReviewsDialog = 'sui-see-all-reviews-dialog';

export const SharedUiPropertyReviewsWrapper: React.FC<SharedUiPropertyReviewsWrapperProps> = inject(
  'currentHotel',
  'context'
)(({ currentHotel, context }) => {
  const propertyId = currentHotel?.hotelId?.toString();
  const isDated = currentHotel?.searchCriteria?.startDate && currentHotel.searchCriteria.startDate.length > 0;
  const searchCriteria = context && currentHotel && adaptSearchCriteria(context, currentHotel.searchCriteria);
  const [isDialogOpen, dialogActions, DialogComponent] = useDialog(sharedUIReviewsDialog, 'pwaDialog');

  const input = React.useMemo(() => {
    if (!propertyId) {
      return null;
    }

    return { propertyId, pagination: { size: 10, startingIndex: 0 }, includeRecentReviews: isDated, searchCriteria };
  }, [propertyId, isDated, searchCriteria]);

  if (!input) {
    return null;
  }
  const onSeeAllReviewsLinkClick = () => {
    dialogActions.openDialog();
  };

  const onDialogClose = () => {
    dialogActions.closeDialog();
  };

  return (
    <ErrorBoundary label="hotel.information.reviews">
      <UitkSpacing margin={{ block: 'six' }}>
        <RefTarget name="Reviews">
          <SimpleLazyLoadWrapper>
            <Experiment name="Disable_Reviews_Container_In_PDP">
              <ExperimentControl>
                <PropertyReviews inputs={input as any} onClickLink={onSeeAllReviewsLinkClick} hideManagementResponse={true} />
                <DialogComponent>
                  <UitkSheet type="full" isVisible={isDialogOpen} triggerRef={null} returnFocusOnClose>
                    <SharedUiPropertyReviewsDialog onDialogClose={onDialogClose} />
                  </UitkSheet>
                </DialogComponent>
              </ExperimentControl>
              <ExperimentVariant bucket={1}></ExperimentVariant>
            </Experiment>
          </SimpleLazyLoadWrapper>
        </RefTarget>
      </UitkSpacing>
    </ErrorBoundary>
  );
});

SharedUiPropertyReviewsWrapper.displayName = 'SharedUiPropertyReviewsWrapper';
